import React, { Component, Fragment, createRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import * as R from 'ramda';
import { isEmptyOrNil } from 'core/helpers';
import { RECOMMENDATIONS_GROUPS } from 'core/constants';

import { RouteLink } from 'components/route-link/route-link';
import { FormattedTag } from 'components/formatted-tag/formatted-tag';
import { prepareSports } from 'helpers/all-inplay';
import { SportIcon } from '../sport-icon/sport-icon';
import { ALL_INPLAY_SPORTS } from '../../../constants';

import './all-inplay-menu-mobile.scss';

export class AllInplayMenuMobile extends Component {
  static propTypes = {
    locale: PropTypes.string.isRequired,
    inplayGames: PropTypes.arrayOf(PropTypes.shape()),
    liveSportId: PropTypes.number,
    isInplayGamesInProgress: PropTypes.bool.isRequired,
    sports: PropTypes.arrayOf(PropTypes.shape()),
    inplayRecommendations: PropTypes.arrayOf(PropTypes.shape()),
    recommendationsGroup: PropTypes.string.isRequired,
    sendSportClickFeedback: PropTypes.func.isRequired,
  };

  static defaultProps = {
    inplayGames: null,
    liveSportId: null,
    sports: null,
    inplayRecommendations: null,
  };

  state = {
    isMounted: false,
  };

  carouselRef = createRef();

  componentDidMount() {
    this.setState({ isMounted: true });
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !R.equals(this.props, nextProps) || !R.equals(this.state, nextState);
  }

  componentDidUpdate(prevProps) {
    const { isInplayGamesInProgress } = this.props;
    const { isInplayGamesInProgress: prevIsInplayGamesInProgress } = prevProps;

    if (!isInplayGamesInProgress && prevIsInplayGamesInProgress) {
      this.scrollToSport();
    }
  }

  scrollToSport = () => {
    const { liveSportId } = this.props;
    const carousel = this.carouselRef && this.carouselRef.current;

    if (carousel) {
      const carouselWidth = carousel.getBoundingClientRect().width;
      const foundSport = carousel.querySelector(`[data-sport-id='${liveSportId}']`);

      if (foundSport) {
        const { offsetLeft, offsetWidth } = foundSport;

        if (offsetLeft + offsetWidth > carouselWidth) {
          carousel.scrollLeft = offsetLeft;
        }
      }
    }
  };

  onClick = (e) => {
    const { dataset: { sportId } } = e.currentTarget;
    const { sendSportClickFeedback } = this.props;

    sendSportClickFeedback(sportId);
  };

  render() {
    const {
      locale,
      liveSportId,
      sports,
      inplayGames,
      isInplayGamesInProgress,
      inplayRecommendations,
      recommendationsGroup,
    } = this.props;
    const { isMounted } = this.state;
    const preparedSports = prepareSports(inplayGames, sports);
    const isDefaultRecommendations = recommendationsGroup === RECOMMENDATIONS_GROUPS.DEFAULT;

    return (
      <div ref={this.carouselRef} className="all-in-play-mobile bg-main-2 rounded overflow-auto">
        {isMounted && (
          <Fragment>
            <div className={classNames('d-flex px-0_25', {
              invisible: isInplayGamesInProgress,
            })}
            >
              {(isDefaultRecommendations || !isEmptyOrNil(inplayRecommendations)) && (
                <RouteLink
                  locale={locale}
                  to="/live"
                  className={classNames('all-in-play-mobile-item flex-shrink-0 d-flex flex-column justify-content-center text-center bg-main-2', {
                    'text-extra-2': liveSportId,
                  })}
                >
                  <SportIcon sportId={ALL_INPLAY_SPORTS} isActive={!liveSportId} locale={locale} />
                  <FormattedTag id={`general.${isDefaultRecommendations ? 'all-sports' : 'for-you'}`} className="mt-0_5 font-weight-bold" />
                </RouteLink>
              )}

              {preparedSports.map(({ sportId, sportName }) => (
                <RouteLink
                  locale={locale}
                  to={`/live/${sportId}`}
                  className={classNames('all-in-play-mobile-item flex-shrink-0 d-flex flex-column justify-content-center text-center bg-main-2', {
                    'text-extra-2': sportId !== liveSportId,
                  })}
                  data-sport-id={sportId}
                  onClick={this.onClick}
                >
                  <SportIcon sportId={sportId} isActive={sportId === liveSportId} locale={locale} />
                  <span className="mt-0_5 font-weight-bold">{sportName}</span>
                </RouteLink>
              ))}
            </div>
          </Fragment>
        )}
      </div>
    );
  }
}
